import { createContext, useCallback, useContext, useMemo } from 'react'

const TranslationContext = createContext()

export const TranslationContextProvider = ({ data, children }) => {
  const translations = useMemo(() => data?.generalTranslations || {}, [data])

  const tGeneral = useCallback(
    (key, options) => {
      let translation = translations[key]

      if (!translation) {
        return key
      }

      if (options) {
        Object.keys(options).forEach((optKey) => {
          translation = translation.replace(`{{${optKey}}}`, options[optKey])
        })
      }

      return translation
    },
    [translations]
  )

  return (
    <TranslationContext.Provider value={{ tGeneral }}>
      {children}
    </TranslationContext.Provider>
  )
}

export function useTranslationContext() {
  const context = useContext(TranslationContext)

  if (!context) {
    throw new Error(
      'useTranslationContext must be used within a TranslationContextProvider'
    )
  }

  return context
}
